"use client";

import Link from "next/link";
import { useTranslations } from "use-intl";
interface CreditsProps {
  className?: string;
}
export const Credits: React.FC<CreditsProps> = ({
  className
}) => {
  const t = useTranslations("common");
  return <div className={className} data-sentry-component="Credits" data-sentry-source-file="Credits.tsx">
      {t("createdBy")} {/* eslint-disable-next-line @shopify/jsx-no-hardcoded-content */}
      <Link href="https://aipss.com" className="font-bold text-yellow-500 transition-all hover:text-yellow-300" rel="noopener noreferrer" target="_blank" data-sentry-element="Link" data-sentry-source-file="Credits.tsx">
        AIPSS
      </Link>
    </div>;
};